import React from "react";
import PhotoAlbum from "react-photo-album";
import image1 from "../images/image1.jpg";
import image2 from "../images/image2.jpg";
import image11 from "../images/image3.jpg";
import image4 from "../images/image4.jpg";
import image5 from "../images/image5.jpg";
import image8 from "../images/image6.jpg";
import image7 from "../images/image7.jpg";
import image6 from "../images/image8.jpg";
import image9 from "../images/image9.jpg";
import image10 from "../images/image10.jpg";
import image3 from "../images/image11.jpg";
import image12 from "../images/image12.jpg";

// Define the array of images with their respective dimensions
const photos = [
  { src: image1, width: 4, height: 6 },
  { src: image2, width: 4, height: 6 },
  { src: image3, width: 4, height: 6 },
  { src: image4, width: 4, height: 3 },
  { src: image5, width: 4, height: 6 },
  { src: image6, width: 1.5, height: 2 },
  { src: image7, width: 4, height: 6 },
  { src: image8, width: 4, height: 3 },
  { src: image9, width: 5, height: 3 },
  { src: image10, width: 4, height: 3 },
  { src: image11, width: 6, height: 4 },
  { src: image12, width: 4, height: 3 },
];

function PhotoGallery() {
  return (
    <>
      <section className="mx-4 mt-[8rem] gallery relative mb-16">
        <h1 className="text-[5rem] md:text-[11rem] opacity-10 font-bold hidden md:block absolute top-[-2.5rem]">
          gallery
        </h1>
        <h2 className="text-[2.5rem] md:pt-[8rem] md:pl-[20rem] border-b border-white mr-[6rem] pl-6 md:border-none mb-10">
          our work
        </h2>
        <PhotoAlbum layout="masonry" photos={photos} />
      </section>
    </>
  );
}

export default PhotoGallery;
